// The catalog content types, and the one the product in the editor uses.
//
// Two readers need them: the shared catalog editor (the tabs read the type's
// flags) and the tab visibility rules, which the CMS asks above the editor,
// before the provider mounts. So the list is cached for the session here
// instead of being fetched twice, and the content type of the product being
// edited is published from the provider for the rules to subscribe to.
import { useEffect, useState } from "react"
import { ListContentTypes } from "../../../AdminShared/api"

let cached = null
let inFlight = null

const loadContentTypes = () => {
  if (cached) return Promise.resolve(cached)
  if (inFlight) return inFlight
  inFlight = ListContentTypes()
    .then((res) => {
      inFlight = null
      cached = res?.list || []
      return cached
    })
    .catch(() => {
      inFlight = null
      return []
    })
  return inFlight
}

/** The catalog content types, cached for the session. */
export function useContentTypes() {
  const [contentTypes, setContentTypes] = useState(cached || [])
  useEffect(() => {
    let alive = true
    loadContentTypes().then((list) => alive && setContentTypes(list))
    return () => {
      alive = false
    }
  }, [])
  return contentTypes
}

// The content type (profile) id of the product the editor has loaded, by pid.
// The store product carries only its `productType`, whose profile the rules
// resolve from the tree until the editor has read the product's own.
let loaded = {}
const listeners = new Set()

export const publishContentTypeId = (pid, contentTypeId) => {
  if (!pid || loaded[pid] === contentTypeId) return
  loaded = { ...loaded, [pid]: contentTypeId }
  for (const listener of listeners) listener(loaded)
}

/** The profile id the editor read for `pid`, or undefined. */
export function useLoadedContentTypeId(pid) {
  const [table, setTable] = useState(loaded)
  useEffect(() => {
    listeners.add(setTable)
    return () => listeners.delete(setTable)
  }, [])
  return pid ? table[pid] : undefined
}
